import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import queryString from "query-string";
import type { Location } from "react-router";
import URI from "urijs";

import type { IOAuthSearchParams } from "../Pages/OAuthHandler";

export interface IGlobalState {
  disableLastMethodForward: boolean;
  initialized: boolean;
  lastMethod: string;
  lastUsername: string;
  loginSuccess: boolean;
  nextUrl: string;
  queryMessage: string;
}

export const defaultState: IGlobalState = {
  disableLastMethodForward: false,
  initialized: false,
  lastMethod: null,
  lastUsername: null,
  loginSuccess: false,
  nextUrl: null,
  queryMessage: null,
};

type TSearchParams = {
  response_type?: string;
  client_id?: string;
  redirect_uri?: string;
  next?: string;
  message?: string;
};
export const globalSlice = createSlice({
  name: "global",
  initialState: defaultState,
  reducers: {
    setNextUrl: (state, { payload }: PayloadAction<IGlobalState["nextUrl"]>) => {
      state.nextUrl = payload;
    },
    setQueryMessage: (state, { payload }: PayloadAction<IGlobalState["queryMessage"]>) => {
      state.queryMessage = payload;
    },
    setLoginSuccess: (state, action: PayloadAction<IGlobalState["loginSuccess"]>) => {
      state.loginSuccess = action.payload;
    },
    setDisableLastMethodForward: (state, { payload }: PayloadAction<IGlobalState["disableLastMethodForward"]>) => {
      state.disableLastMethodForward = payload;
    },
    initializeGlobal(state, { payload }: PayloadAction<Location>) {
      const location = payload;
      const parsedQueryString = queryString.parse(location.search) as TSearchParams;
      const isOauthRequest =
        parsedQueryString.redirect_uri !== undefined &&
        parsedQueryString.response_type !== undefined &&
        parsedQueryString.client_id !== undefined;
      const concatURLString = (loginUrl: string, searchValues: IOAuthSearchParams): string => {
        return String(new URI(loginUrl).addSearch(searchValues));
      };

      const removeKey = (object, key) => {
        const { [key]: deletedKey, ...otherKeys } = object;
        return otherKeys;
      };

      if (isOauthRequest) {
        // We don't want the "next" parameter to be concated with rest of the search, so we remove it before concatenate the url"
        const next = concatURLString(parsedQueryString.next, removeKey(parsedQueryString, "next"));
        state.nextUrl = next;
        state.queryMessage = parsedQueryString.message;
      } else if (parsedQueryString.next || parsedQueryString.message) {
        const { next, message } = parsedQueryString;
        state.nextUrl = next;
        state.queryMessage = message;
      } else {
        const { next, message } = location.state || { next: undefined, message: undefined };
        state.nextUrl = next;
        state.queryMessage = message;
      }
      state.initialized = true;
    },
  },
});
